<template>
	<div>
		<!-- 登录 pc用 -->
		<div class="hidden-sm-and-down login-outer">
			<div class="login-wrap">
				<div class="u-flex title u-row-center">
					<img src="../assets/logo.png">
					<span class="cf u-font-38" v-if="reset">重置密码</span>
					<span class="cf u-font-38" v-else>千村调查系统{{text}}</span>
				</div>
				<el-input clearable placeholder="请输入手机号" v-model="form.phone" type='number'>
					<i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
				</el-input>
				<el-input clearable placeholder="请输入短信验证码" v-model="form.code" class="u-m-t-20" v-if="!flag||reset">
					<i slot="prefix" class="el-input__icon el-icon-unlock"></i>
					<el-button style="font-size: 0.0625rem;" slot="append" @click='getCode'>{{timeText}}</el-button>
				</el-input>
				<el-input clearable placeholder="请输入登录密码" v-model="form.password" class="u-m-t-20" v-else type="password">
					<i slot="prefix" class="el-input__icon el-icon-key"></i>
				</el-input>
				<div v-show="reset">
					<el-input clearable placeholder="请输入新登录密码" v-model="form.password" class="u-m-t-20">
						<i slot="prefix" class="el-input__icon el-icon-key"></i>
					</el-input>
					<el-input clearable placeholder="请确认新登录密码" v-model="form.password_again" class="u-m-t-20">
						<i slot="prefix" class="el-input__icon el-icon-key"></i>
					</el-input>
				</div>
				<div v-if="!flag&&!reset">
					<el-input clearable placeholder="请输入姓名" v-model.trim="form.name" class="u-m-t-20">
						<i slot="prefix" class="el-input__icon el-icon-user"></i>
					</el-input>
				
					<el-input clearable placeholder="请输入工作单位" v-model.trim="form.work_company" class="u-m-t-20">
						<i slot="prefix" class="el-input__icon el-icon-office-building"></i>
					</el-input>
					
					<el-select v-model="form.user_type" placeholder="请选择身份类型" class="u-m-t-20" clearable >
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					
					<el-input clearable placeholder="请输入邮箱" v-model.trim="form.email" class="u-m-t-20">
						<i slot="prefix" class="el-input__icon el-icon-message"></i>
					</el-input>
					
					<el-input clearable placeholder="请输入研究兴趣" v-model.trim="form.research_interest" class="u-m-t-20">
						<i slot="prefix" class="el-input__icon el-icon-reading"></i>
					</el-input>
					
					<el-input clearable placeholder="请设置登录密码" v-model.trim="form.password" class="u-m-t-20">
						<i slot="prefix" class="el-input__icon el-icon-key"></i>
					</el-input>
					<el-input clearable placeholder="请确认登录密码" v-model.trim="form.password_again" class="u-m-t-20">
						<i slot="prefix" class="el-input__icon el-icon-key"></i>
					</el-input>
					
				</div>
				<el-button class="log-btn" @click='submit' v-if="!reset">{{text}}</el-button>
				<el-button class="log-btn" @click='reset_pwd' v-else>重置密码</el-button>
				<div :class="{'u-row-between':flag,'u-row-right':!flag}" class="u-flex">
					<span class="cf tips" v-show="flag" @click="changeReset">{{isReset}}</span>
					<span class="cf tips" @click="changeFlag" v-show="!reset">{{isHas}}</span>
				</div>
			</div>
		</div>
		<!-- 登录 移动端用 -->
		<div class="hidden-md-and-up mobile-wrap">
			<div class="hello-wrap u-relative">
				<div class="hello">Hello，</div>
				<div class="hello">欢迎访问千村调查系统！</div>
				<div class="u-absolute"></div>
			</div>
			<el-input clearable placeholder="请输入手机号" v-model="form.phone" type='number' class="my-input">
				<i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
			</el-input>
			<el-input clearable placeholder="请输入短信验证码" v-model="form.code" class="u-m-t-10" v-if="!flag||reset">
				<i slot="prefix" class="el-input__icon el-icon-unlock"></i>
				<el-button slot="append" @click='getCode'>{{timeText}}</el-button>
			</el-input>
			<el-input clearable placeholder="请输入登录密码" v-model="form.password" class="u-m-t-10" v-else type="password">
				<i slot="prefix" class="el-input__icon el-icon-key"></i>
			</el-input>
			<div v-show="reset">
				<el-input clearable placeholder="请输入新登录密码" v-model="form.password" class="u-m-t-10">
					<i slot="prefix" class="el-input__icon el-icon-key"></i>
				</el-input>
				<el-input clearable placeholder="请确认新登录密码" v-model="form.password_again" class="u-m-t-10">
					<i slot="prefix" class="el-input__icon el-icon-key"></i>
				</el-input>
			</div>
			<div v-if="!flag&&!reset">
				<el-input clearable placeholder="请输入姓名" v-model.trim="form.name" class="u-m-t-10">
					<i slot="prefix" class="el-input__icon el-icon-user"></i>
				</el-input>
			
				<el-input clearable placeholder="请输入工作单位" v-model.trim="form.work_company" class="u-m-t-10">
					<i slot="prefix" class="el-input__icon el-icon-office-building"></i>
				</el-input>
				
				<el-select v-model="form.user_type" placeholder="请选择身份类型" class="u-m-t-10" clearable >
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				
				<el-input clearable placeholder="请输入邮箱" v-model.trim="form.email" class="u-m-t-10">
					<i slot="prefix" class="el-input__icon el-icon-message"></i>
				</el-input>
				
				<el-input clearable placeholder="请输入研究兴趣" v-model.trim="form.research_interest" class="u-m-t-10">
					<i slot="prefix" class="el-input__icon el-icon-reading"></i>
				</el-input>
				
				<el-input clearable placeholder="请设置登录密码" v-model.trim="form.password" class="u-m-t-10">
					<i slot="prefix" class="el-input__icon el-icon-key"></i>
				</el-input>
				<el-input clearable placeholder="请确认登录密码" v-model.trim="form.password_again" class="u-m-t-10">
					<i slot="prefix" class="el-input__icon el-icon-key"></i>
				</el-input>
			</div>
			<el-button class="log-btn" @click='submit' v-if="!reset">{{text}}</el-button>
			<el-button class="log-btn" @click='reset_pwd' v-else>重置密码</el-button>
			<div :class="{'u-row-between':flag,'u-row-right':!flag}" class="u-flex">
				<span class="cm tips" v-show="flag" @click="changeReset">{{isReset}}</span>
				<span class="cm tips" @click="changeFlag" v-show="!reset">{{isHas}}</span>
			</div>
				
			</div>
			
		</div>
	</div>
</template>

<script>
	import {
	  getToken,
	  removeToken,
	  setToken,
	  removeCookie,
	  getCookie
	} from "@/utils/auth";
	export default {
		name: 'Login',
		components: {},
		data() {
			return {
				form: {
					phone: '',
					code: '',
					name: '',
					work_company: '',
					user_type:'',
					email:'',
					research_interest:'',
					password:'',
					password_again:'',
				},
				flag: true, // true登录  false 注册
				reset:false, // 重置密码
				timeText: '获取验证码',
				timmer: null,
				options: []
			}
		},
		computed: {
			isHas() {
				return this.flag ? '没有账号？立即注册' : '已有账号？立即登录'
			},
			isReset() {
				return this.reset ? '返回登录' : '忘记密码'
			},
			text() {
				return this.flag ? '登录' : '注册'
			}
		},
		async mounted() {
			const options = await this.$API.user_type({
				action: 'out_reg'
			})
			for (let key in options) {
				this.options.push({
					value: key,
					label: options[key].substr(2)
				})
			}
		},
		methods: {
			changeFlag() {
				this.flag = !this.flag
				this.form.phone = ''
				this.form.code = ''
				this.form.name = ''
				this.form.work_company = ''
				this.form.user_type = ''
				this.form.email = ''
				this.form.research_interest = ''
				this.form.password = ''
				this.form.password_again = ''
				
				this.timmer && clearInterval(this.timmer)
				this.timeText = '获取验证码'
			},
			changeReset() {
				this.reset = !this.reset
				this.form.phone = ''
				this.form.code = ''
				this.form.password_again = ''
				this.form.password = ''
				
				this.timmer && clearInterval(this.timmer)
				this.timeText = '获取验证码'
			},
			async getCode() {
				if (this.timeText != '获取验证码') {
					return
				}
				if (!this.vilidatePhone()) {
					return
				}
				let action=''
				if(this.reset){
					action='change_pwd'
				}else if(this.flag){
					action='login'
				}else{
					action='reg'
				}
				const code = await this.$API.get_code({
					phone: this.form.phone,
					action
				})
				this.$message.success('发送成功')
				this.timeText = '发送中...'
				let num = 60
				this.timmer = setInterval(() => {
					num--;
					this.timeText = num + '秒后重新获取'
					if (num == 0) {
						clearInterval(this.timmer)
						this.timeText = '获取验证码'
					}
				}, 1000)

			},
			async reset_pwd(){
				if (!this.vilidatePhone()) {
					return
				}
				if (!this.form.code) {
					this.$message.error('请输入短信验证码')
					return
				}
				if (!this.form.password) {
					this.$message.error('请输入新登录密码')
					return
				}
				if (!this.form.password_again) {
					this.$message.error('请确认新登录密码')
					return
				}
				if (this.form.password!=this.form.password_again) {
					this.$message.error('两次密码不一致!')
					return
				}
				
				await this.$API.loginReg({
						phone: this.form.phone,
						action: 'change_pwd',
						code: this.form.code,
						password: this.form.password,
					})
				this.$message.success('重置成功,请登录')	
				this.changeReset()
			},
			async submit() {
				if (!this.vilidatePhone()) {
					return
				}
				if (!this.form.password) {
					this.$message.error('请输入登录密码')
					return
				}
				// 对接登录或注册 action=>区分登陆和注册
				if (this.flag) {
					// 登录
					const res = await this.$API.login({
						username: this.form.phone,
						password: this.form.password
						// phone: this.form.phone,
						// action: 'login',
						// code: this.form.code
					})
					// console.log(this.$cookieStore.getCookie( 'csrftoken' ),"csrftoken1");
					// localStorage.setItem('token', res.data.token)
					setToken(res.data.token);
					localStorage.setItem('expires', res.data.expires)
					this.$API.user_info().then(res => {
						this.$store.state.username = res.name
						this.$store.state.is_out_user = res.is_out_user
					})
					// this.$cookieStore.delCookie( 'csrftoken' )
					// this.$cookieStore.delCookie( 'sessionid' )
					// console.log(this.$cookieStore.getCookie( 'csrftoken' ),"csrftoken2");
					this.$router.replace('/data')
					// 会刷新一次 体验有点差 防止登录过期后当前页被路缓存后不渲染获取数据了
					// location.reload();
				} else {
					if (!this.form.code) {
						this.$message.error('请输入短信验证码')
						return
					}
					if (!this.form.name) {
						this.$message.error('请输入姓名')
						return
					}
					if (!this.form.work_company) {
						this.$message.error('请输入工作单位')
						return
					}
					if (!this.form.user_type) {
						this.$message.error('请选择身份类型')
						return
					}
					if (!this.form.email) {
						this.$message.error('请输入邮箱')
						return
					}
					const reg_email=/^([a-zA-Z0-9]+[_|_|\-|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,6}$/
					if (!reg_email.test(this.form.email)) {
						this.$message.error('请输入合法的邮箱')
						return
					}
					if (!this.form.research_interest) {
						this.$message.error('请输入研究兴趣')
						return
					}
					if (!this.form.password) {
						this.$message.error('请设置登录密码')
						return
					}
					if (!this.form.password_again) {
						this.$message.error('请确认登录密码')
						return
					}
					if (this.form.password!=this.form.password_again) {
						this.$message.error('两次密码不一致!')
						return
					}
					// 注册
					await this.$API.loginReg({
						phone: this.form.phone,
						action: 'reg',
						code: this.form.code,
						name: this.form.name,
						work_company: this.form.work_company,
						user_type: this.form.user_type,
						email: this.form.email,
						research_interest: this.form.research_interest,
						password: this.form.password,
					})
					this.$message.success('注册成功,请登录')
					this.changeFlag()
				}
			},
			vilidatePhone() {
				const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
				if (!this.form.phone) {
					this.$message.error('请输入手机号')
					return false
				}
				if (!reg.test(this.form.phone)) {
					this.$message.error('手机号格式不正确')
					return false
				}
				return true
			}
		},

	}
</script>


<style lang="less" scoped>
	.el-select{
		width: 100%;
	}
	.login-outer {
		height: 100vh;
		background: url(https://login.sufe.edu.cn/login/img/BG_1.png) no-repeat;
		background-size: 100% 100%;

	}

	.login-wrap {
		width: 2.604166rem;
		// height: 675px;
		background-color: rgba(0, 0, 0, 0.7);
		border-radius: 10px;
		padding: 0.15625rem 0.3125rem;
		box-sizing: border-box;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		// top: 60px;
		right: 0.625rem;
		.u-font-38{
			font-size: 0.197916rem;
		}
		.u-m-t-20{
			margin-top: 0.104166rem;
		}
		.title {
			margin-bottom: 0.104166rem;
		}

		img {
			width: 0.291666rem;
			height: 0.291666rem;
			margin-right: 0.104166rem;
		}
		.el-button{
			padding: 0 !important;
		}
		.log-btn {
			font-size: 0.072916rem;
			width: 100%;
			height: 0.260416rem;
			line-height: 0.260416rem;
			background-color: #7c2326;
			color: #fff;
			border: none;
			margin-top: 0.104166rem;
			
		}
		/deep/ .el-input-group__append{
			padding: 0 0.208333rem !important;
		}
		/deep/  .el-input__icon{
			line-height: 1 !important;
		}
		/deep/ .el-input__inner {
			height: 0.260416rem;
			line-height: 0.260416rem;
			// border-radius: 30PX;
			font-size: 0.072916rem;
		}
		
		.tips {
			font-size: 0.072916rem;
			cursor: pointer;
			margin-top: 0.15625rem;
			display: inline-block;
		}


	}

	.mobile-wrap {
		padding: 20PX 30PX 0;

		.hello-wrap {
			margin-bottom: 20PX;
			z-index: 9;

			.hello {
				color: #333333;
				font-size: 24PX;
			}

			.u-absolute {
				top: 24PX;
				width: 266PX;
				height: 10PX;
				opacity: 0.8;
				z-index: 1;
				background: linear-gradient(to right, #d1383d, rgba(255, 255, 255, 0));
				border-radius: 5PX;
			}
		}

		.log-btn {
			width: 100%;
			height: 48PX;
			// line-height: 64px;
			background-color: #7c2326;
			color: #fff;
			// border: none;
			margin-top: 20PX;
			border-radius: 24PX;
		}

		/deep/ .el-input__inner {
			height: 40PX;
			line-height: 40PX;
			// border-radius: 30PX;
		}

		i {
			font-size: 16PX;
		}

		.tips {
			cursor: pointer;
			margin-top: 18PX;
			display: inline-block;
			font-size: 12px;
		}
	}
</style>
<style lang="less">
	/* 处理input type='number'出现右侧箭头 */
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	input[type="number"] {
		-moz-appearance: textfield;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	/* .avatar-uploader .el-upload:hover {
			border-color: #7c2326;
		} */
	.el-upload--picture-card:hover,
	.el-upload:focus {
		border-color: #7c2326 !important;
		color: #7c2326 !important;
	}

	.choose-img {
		width: 200px;
		height: 120px;
		box-sizing: border-box;
		padding: 20px;

		.avatar-uploader-icon {
			font-size: 32px;
			color: #fff;
			// width: 178px;
			// height: 178px;
			// line-height: 178px;
			// text-align: center;
		}


	}

	.avatar {
		width: 200px !important;
		height: 120px !important;
		display: block;
		margin-right: 0 !important;
	}

	.choose-img-phone {
		width: 120px;
		height: 75px;
		box-sizing: border-box;
		padding: 20px 10px;

		.avatar-uploader-icon {
			font-size: 32px;
			color: #fff;
			// width: 178px;
			// height: 178px;
			// line-height: 178px;
			// text-align: center;
		}


	}

	.avatar-phone {
		width: 120px !important;
		height: 75px !important;
		display: block;
		margin-right: 0 !important;
	}
</style>
